var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3989 17.7094V4.51124C14.3983 4.26482 14.2994 4.0287 14.1241 3.85458C13.9489 3.68063 13.7113 3.58263 13.4634 3.58232H4.31523V0.2201C4.31523 0.0984746 4.41426 0 4.53643 0H17.7775C17.8997 0.000475729 17.9989 0.0984746 18 0.2201V17.4887C17.9989 17.6103 17.8997 17.7083 17.7775 17.7088L14.3989 17.7094ZM13.4636 4.2896L0.222476 4.28976C0.100313 4.29007 0.00111458 4.38823 0 4.5097V21.7799C0.00111638 21.9015 0.100313 21.9995 0.222476 22H13.4636C13.5856 21.9992 13.6841 21.9012 13.6849 21.7799V4.51132C13.6841 4.39017 13.5856 4.29202 13.4636 4.29122V4.2896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy1);
export default __webpack_public_path__ + "static/media/Copy1.31c04fed2dbb17478a4d7e466e9ec782.svg";
export { ForwardRef as ReactComponent };